import {
  Controller,
  FieldValues,
  Path,
  UseControllerProps,
} from 'react-hook-form';
import { StyledSwitch, StyledSwitchProps } from './StyledSwitch.tsx';

type HookFormSwitchProps<TFieldValues extends FieldValues> =
  StyledSwitchProps & {
    control: UseControllerProps<TFieldValues>['control'];
    name: Path<TFieldValues>;
  };

export const HookFormSwitch = <TFieldValues extends FieldValues>(
  props: HookFormSwitchProps<TFieldValues>,
) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field }) => (
        <StyledSwitch
          checked={!!field.value}
          onChange={(e) => field.onChange(e.target.checked)}
        />
      )}
    />
  );
};
